export const algoliaConfigurations = {
  session: {
    activeSession: false,
    areaOfStudy: "session.subject_area_sublevels",
    career: false /* IGNORED */,
    cities: "session.session_travel_details.arrival_city.city_ascii",
    academicYear: "session.academic_year",
    classActive: false,
    countries: "session.session_travel_details.arrival_city.country.name",
    courseLevel: "session.education_levels.value",
    courseSearch: false /* IGNORED */,
    hostInstitution: "session.session_hosting_institutions.entity.name",
    internshipStatus: false,
    keyword: false,
    language: "session.classes_language_of_instruction.value",
    pastPrograms: "session.application_deadline",
    price: "session.base_price_in_cents",
    // Flag-on (hasDisplayStudentDiscountEnabled) attribute — `AlgoliaSideBar` suffixes `.${domainEntityId}`.
    pricesAttribute: "session.prices",
    // programLength: "session.terms.tags.name",
    // temporarily per JUAN-513
    programLength: false,
    programPageStatus: "program_page.status_id",
    programTypes: "session.session_types.name",
    searchByDate: false /* IGNORED */,
    sessionId: false,
    sessionStatusId: "session.status_id",
    terms: "session.term_session_names",
    programsMarketPlace: "program_page.marketplace",
    sessionsMarketPlace: "session.marketplace",
    internshipsMarketPlace: false,
    sessionsSharedWith: "session.shared_with",
    sessionHideFromSearch: "session.hide_from_search",
    sessionsDomainRestrictedId: "session.excluded_entity_ids",
    programsDomainRestrictedId: "program_page.excluded_entity_ids",
    classesVisibility: false,
    programsPageOwnerEntityIdFilter: "program_page.owner_entity_id",
    sessionsOwnerEntityIdFilter: "session.owner_entity_id",
    internshipsOwnerEntityIdFilter: false,
    programFeatures: "session.program_features",
    // Instant Scholarships — `AlgoliaResults` suffixes `.${domainEntityId}` and filters `= 1`.
    hasDiscount: "session.hdisc",
  },
  internship: {
    activeSession: false,
    areaOfStudy: "internship.subject_area_sublevels",
    career: "internship.career_interests.soc_title",
    cities: "session.session_travel_details.arrival_city.city_ascii",
    academicYear: "session.academic_year",
    classActive: false,
    countries: "session.session_travel_details.arrival_city.country.name",
    courseLevel: false /* IGNORED */,
    courseSearch: false /* IGNORED */,
    hostInstitution: false /* IGNORED */,
    internshipStatus: "internship.status",
    keyword: false,
    language: "internship.required_languages.value",
    pastPrograms: "session.application_deadline",
    price: "session.base_price_in_cents",
    // Flag-on (hasDisplayStudentDiscountEnabled) attribute — `AlgoliaSideBar` suffixes `.${domainEntityId}`.
    pricesAttribute: "session.prices",
    programLength: false, //"internship.terms.tags.name",
    programPageStatus: "program_page.status_id",
    programTypes: "session.session_types.name",
    searchByDate: false /* IGNORED */,
    sessionId: false,
    sessionStatusId: "session.status_id",
    terms: "session.term_session_names",
    programsMarketPlace: "program_page.marketplace",
    sessionsMarketPlace: "session.marketplace",
    internshipsMarketPlace: "internship.marketplace",
    sessionsDomainRestrictedId: "session.excluded_entity_ids",
    programsDomainRestrictedId: "program_page.excluded_entity_ids",
    classesVisibility: false,
    sessionsSharedWith: "session.shared_with",
    sessionHideFromSearch: "session.hide_from_search",
    programsPageOwnerEntityIdFilter: "program_page.owner_entity_id",
    sessionsOwnerEntityIdFilter: "session.owner_entity_id",
    internshipsOwnerEntityIdFilter: "internship.owner_entity_id",
    programFeatures: "session.program_features",
    // Internship records carry the same `session` payload, so the attribute resolves identically.
    hasDiscount: "session.hdisc",
  },
  classes: {
    activeSession: "class.active_session",
    areaOfStudy: "class.subject_area_sublevels",
    career: false /* IGNORED */,
    cities: "class.host_institution.shipping_address_city",
    academicYear: false /* IGNORED */,
    classActive: "class.status",
    countries: "class.host_institution.country.name",
    courseLevel: "class.level.value",
    courseSearch: false /* IGNORED */,
    hostInstitution: "class.host_institution.name",
    internshipStatus: false,
    keyword: false,
    language: "class.language_of_instruction.value",
    pastPrograms: false,
    price: false /* IGNORED */,
    pricesAttribute: false /* IGNORED */,
    programLength: false, //"class.terms.tags.name",
    programPageStatus: false,
    programTypes: false /* IGNORED */,
    searchByDate: false /* IGNORED */,
    sessionId: "class.sessions.session_id",
    sessionStatusId: false,
    terms: "class.term_session_names",
    programsMarketPlace: false,
    sessionsMarketPlace: false,
    internshipsMarketPlace: false,
    sessionsSharedWith: false,
    sessionHideFromSearch: false,
    sessionsDomainRestrictedId: false,
    programsDomainRestrictedId: false,
    classesVisibility: true,
    classesPubliclyVisible: "class.publicly_visible",
    classesPublicExcludedEntityIds: "class.public_excluded_entity_ids",
    classesEntityVisibleIds: "class.entity_visible_ids",
    programsPageOwnerEntityIdFilter: false,
    sessionsOwnerEntityIdFilter: false,
    internshipsOwnerEntityIdFilter: false,
    programFeatures: false,
    hasDiscount: false,
  },
};
